'use client';

import React from 'react';
import { IconCreditCard, IconReceivePayment } from '@repo/svgs';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { DataCell, Divider } from '@/components/ui';
import { useOwner } from '../../context/OwnerProvider';
import { cn } from '@/lib/cn';

export function OwnerRentsAndDeposits() {
  const { aggResponse, isMasked } = useOwner();

  const renderDepositText = () => {
    if (!aggResponse?.numReceivedDepositReviews) return '-';
    return `${aggResponse.recDepositPerc}%`;
  };

  const renderElectronicPaymentText = () => {
    if (!aggResponse?.numElectronicPaymentReviews) return '-';
    return aggResponse?.numElectronicPayment ? 'Accepts' : 'Does not accept';
  };

  return (
    <div className="flex flex-col w-full">
      {/* Section Header */}
      <SectionHeader title="Rents and deposits" />

      {/* Content */}
      <div className={cn('md:px-2')}>
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-4">
          <DataCell
            icon={<IconReceivePayment className="w-6 h-6 icon-secondary" />}
            value={renderDepositText()}
            description="Renters received their security deposits back"
            isMasked={isMasked}
          />

          <div className="flex items-center justify-center md:hidden py-1">
            <Divider />
          </div>

          <DataCell
            icon={<IconCreditCard className="w-6 h-6 icon-secondary" />}
            value={renderElectronicPaymentText()}
            description="Electronic rent payments"
            isMasked={isMasked}
          />
        </div>
      </div>
    </div>
  );
}
